module.exports = __webpack_public_path__ + "img/Frame 1321315180@2x.224c00c0.png";